import { formatScore } from "@/utils/helperFunctions/formatMsToTime";

// Formats a stored score (the racing lap-time value lives in
// userChallengeData.points) into a display string, gracefully falling back to
// the raw value if it can't be parsed as a time. Keeps the board's em-dash
// empty placeholder.
export const formatRacingTime = (
  points: string | number | undefined
): string => {
  if (points === undefined || points === "") return "—";
  return formatScore(points);
};

// Gap-to-leader for the racing board. Lap times are stored as numeric
// milliseconds (lower = faster), so the gap is `driver - leader`. Returns a
// "+s.mmm" string for anyone behind the leader, and "" for the leader itself or
// when either value isn't a numeric time (point-based games fall back to blank).
export const formatGap = (
  points: string | number | undefined,
  leaderPoints: string | number | undefined
): string => {
  if (points == null || leaderPoints == null) return "";

  const driver = Number(points);
  const leader = Number(leaderPoints);
  if (Number.isNaN(driver) || Number.isNaN(leader)) return "";

  const diffMs = driver - leader;
  if (diffMs <= 0) return "";

  return `+${(diffMs / 1000).toFixed(3)}`;
};
